import { useState, useEffect } from "react";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const DESKTOP_SIZE_START = 768;

const isDesktopDimension = () => getWindowDimensions().width > DESKTOP_SIZE_START;

export default function useWindowDimensions() {
  const [isDesktop, setIsDesktop] = useState(isDesktopDimension());

  useEffect(() => {
    function handleResize() {
      setIsDesktop(isDesktopDimension());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isDesktop;
}
